import axios from './axios';

export const getCertificates = async () => {
  try {
    const response = await axios.get('/certifications');
    return response.data.data;
  } catch(e) {
      console.error(e);
  }    
};

export const getRestaurants = async () => {
  try {
    const response = await axios.get('/restaurants');
    return response.data.data;
  } catch(e) {
      console.error(e);
  }    
};

export const deleteCertificate = async (id) => {
  try {
    const response = await axios.delete(`/certifications/${id}`);
    return response.data.data;
  } catch(e) {
      console.error(e);
  }    
};

export const uploadPhoto = async (file) => {
  const response = await axios.post('/uploads/image', file, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data.data; 
};

export const addCertificate = async (data) => {
  const response = await axios.post('/certifications', data);
  return response.data.data;
};

export const updateCertificate = async (certificateId, data) => {
  const response = await axios.put(`/certifications/${certificateId}`, data);
  return response.data.data;   
};

